import { render, staticRenderFns } from "./OpenSelfcareButton.vue?vue&type=template&id=60f745d2"
import script from "./OpenSelfcareButton.vue?vue&type=script&lang=ts"
export * from "./OpenSelfcareButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports